var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-box" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.info.insuranceInfo,
            border: "",
            size: "mini",
            "max-height": "400px",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "insuranceNo", label: "编号", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "applicantName",
              label: "投保人姓名",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "applicantIdCard",
              label: "投保人身份证",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "insurancePrice", label: "保费", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "insuranceOrderNo",
              label: "保单号",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "insuranceProgramCode",
              label: "保险方案代码",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "errorMsg", label: "错误信息", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "applicantTime",
              label: "投保时间",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "insureEffectTime",
              label: "投保生效时间",
              align: "center",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }